var exports = {
  "iE": "x31de4314--42722b--wrapper",
  "wx": "x31de4314--42722b--header",
  "Qq": "x31de4314--42722b--text",
  "Zg": "x31de4314--42722b--emoji",
};

module.exports = exports;
